import { Drama } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useParams } from "@tanstack/react-router";
import { FeedbackTray } from "@/components/Feedback/FeedbackTray";
import { useFeatureFlags } from "@/contexts/FeatureFlagContext";
import type { Trope } from "@/types/summary";
import { isInsightPresent } from "@/utils/isInsightPresent";
import { CollapsibleCard } from "./CollapsibleCard";
import { TropeSubcard } from "./TropeSubcard";
import { UnavailableInsightCard } from "./UnavailableInsightCard";

const MAX_TROPES = 5;

interface TropesCardProps {
  tropes?: Trope[];
}

export function TropesCard({ tropes }: TropesCardProps) {
  const { t } = useTranslation("jobDetails");
  const { jobId } = useParams({ from: "/jobs/$jobId", strict: true });
  const { features } = useFeatureFlags();

  if (!isInsightPresent.tropes(tropes)) {
    if (!features.tropes) return null;
    return <UnavailableInsightCard insight="tropes" />;
  }

  return (
    <FeedbackTray
      cardTestId="tropes"
      jobId={jobId}
      contentType="tropes"
      promptKey="feedback.tropes.prompt"
    >
      <CollapsibleCard
        icon={Drama}
        title={t("tropesCard.title")}
        testId="tropes"
        showExperimentalBadge
      >
        <div className="mt-5 space-y-4">
          {tropes.slice(0, MAX_TROPES).map((trope, index) => (
            <TropeSubcard
              key={`${trope.name}-${index}`}
              trope={trope}
              index={index}
            />
          ))}
        </div>
      </CollapsibleCard>
    </FeedbackTray>
  );
}
